import { useState, type ReactNode, type ReactElement } from 'react';
import { DynamicPage, DynamicPageTitle, Title, Bar, Input, Icon, BusyIndicator, MessageStrip, Button, FlexBox } from '@ui5/webcomponents-react';
import { useIsMobile } from '../hooks/useIsMobile';

interface Props {
  title: string; count?: number; loading: boolean; error?: Error | null;
  search: string; onSearch(v: string): void; actions?: ReactElement | ReactElement[]; children: ReactNode;
  /** Optional control rendered next to the search box (barcode scanning). */
  scan?: ReactNode;
  onLoadMore?(): void; hasMore?: boolean;
}

/** Fiori list-report style page: title, search, table, load-more. */
export function ListPage({ title, count, loading, error, search, onSearch, actions, children, onLoadMore, hasMore, scan }: Props) {
  const [draft, setDraft] = useState(search);
  const isMobile = useIsMobile();
  return (
    <DynamicPage
      // Phone: the filter/action controls wrap in their own row under the title (a Bar never wraps and gets cut off).
      titleArea={<DynamicPageTitle heading={<Title level="H3">{title}{count != null ? ` (${count})` : ''}</Title>} actionsBar={isMobile ? undefined : <Bar design="Subheader" endContent={actions} />} />}
      style={{ height: '100%' }}
    >
      {isMobile && actions && <FlexBox wrap="Wrap" alignItems="Center" style={{ gap: '0.5rem', marginBottom: '0.5rem' }}>{actions}</FlexBox>}
      <FlexBox style={{ gap: '0.5rem', marginBottom: '0.5rem' }} alignItems="Center">
        <Input placeholder="Search…" value={draft} icon={<Icon name="search" />} showClearIcon style={{ width: 'min(24rem, 100%)' }}
          onInput={e => setDraft(e.target.value ?? '')} onChange={e => onSearch(e.target.value ?? '')} />
        {scan}
        {loading && <BusyIndicator active size="S" />}
      </FlexBox>
      {error && <MessageStrip design="Negative" hideCloseButton>{error.message}</MessageStrip>}
      <div style={{ overflowX: 'auto' }}>{children}</div>
      {hasMore && <FlexBox justifyContent="Center" style={{ margin: '0.75rem' }}><Button onClick={onLoadMore} disabled={loading}>Load more</Button></FlexBox>}
    </DynamicPage>
  );
}
